import { render, staticRenderFns } from "./FileUploadDetails.vue?vue&type=template&id=47722a98&scoped=true&"
import script from "./FileUploadDetails.vue?vue&type=script&lang=js&"
export * from "./FileUploadDetails.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadDetails.vue?vue&type=style&index=0&id=47722a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47722a98",
  null
  
)

export default component.exports